import Vue from 'vue';


export default Vue.extend({
  data() {
    return {
      appName: '',
      stage: '',
      progress: [],
      multiProgress: [],
      confirmProgress: [],
      actionProgress: [],
    };
  },
  computed: {
    instance() {
      return this.$store.state.instance;
    },
    currentApp() {
      return this.$store.state.currentApp;
    },
    currentStep() {
      return this.$store.state.currentStep;
    },
  },
  created() {
    // name the title.
    this.$store.commit('SET_APP', this.$route.meta.appName);
    // prepare the data after login.
    if (this.$store.state.route.from.name === 'Login') {
      this.$store.dispatch('removeLogoutTimeout');
      this.$store.dispatch('setLogoutTimeout');
      this.$store.dispatch('getSystemInfo');
      this.$store.dispatch('getDrugInDevices');
      this.$store.dispatch('getDisabledDevices');
    }
    // initiate automatically logout
    this.$store.dispatch('removeLogoutTimeout');
    this.$store.dispatch('setLogoutTimeout');
  },
  mounted() {
    this.checkVariableInitiated();
  },
  methods: {
    checkVariableInitiated() {
      if (this.stage === '') console.error('stage not initiated.');

      // setup progress
      if (this.progress.length === 0) {
        console.error('progress not initiated');
      } else {
        this.$store.commit('SET_PROGRESS', this.progress);
      }

      if (this.multiProgress.length === 0) console.warn('multiProgress not initiated');
      if (this.confirmProgress.length === 0) console.warn('confirmProgress not initiated');
      if (this.actionProgress.length === 0) console.warn('actionProgress not initiated');
    },
    cancel() {
      // make sure all apps have cancel function.
      console.error('cancel function not implemented');
    },
  },
});



// WEBPACK FOOTER //
// ./src/components/ComponentBase/AppBase.js